import { FormulaReferenceOption } from './types';

export const getIndicesOf = (searchString: string, text: string, caseSensitive = false): number[] => {
  if (!searchString.length) {
    return [];
  }

  const searchableText = caseSensitive ? text : text.toLocaleLowerCase();
  const searchableString = caseSensitive ? searchString : searchString.toLocaleLowerCase();
  const indices: number[] = [];
  let startIndex = 0;
  let index = searchableText.indexOf(searchableString, startIndex);

  while (index > -1) {
    indices.push(index);
    startIndex = index + searchableString.length;
    index = searchableText.indexOf(searchableString, startIndex);
  }

  return indices;
};

export const getEntityRanges = (text: string, mentionName: string, mentionKey: number) => {
  const indices = getIndicesOf(mentionName, text);

  return indices.length
    ? indices.map(offset => ({
      key: mentionKey,
      length: mentionName.length,
      offset
    }))
    : null;
};

export const getOptionsToDisplay = <T extends FormulaReferenceOption>(options: T[], notClickableIds: string[]): T[] => {
  const nonClickableIds = new Set(notClickableIds);

  return options.filter((option, index) => {
    if (!nonClickableIds.has(String(option.id))) {
      return true;
    }

    const nextOption = options[index + 1];
    if (!nextOption) {
      return false;
    }

    // If the next option is nested underneath this one (e.g. a sub-group header, or a leaf entry),
    // this header has content and should be kept, even if that next option is itself non-clickable
    // (e.g. a sub-group header with its own children further down the list).
    if ((nextOption.depth ?? 0) > (option.depth ?? 0)) {
      return true;
    }

    return !nonClickableIds.has(String(nextOption.id));
  });
};
